const mutations = {
    setMailinglist(state,payload) {
        state.mailinglist = payload
    }
}

export default mutations